// extracted by mini-css-extract-plugin
module.exports = {"grid":"StandardConfig_grid__CXOZf"};